// Models
import Model from './Model'

class ProfileCustomer extends Model {
  get isBlocked () {
    return this.status === CUSTOMER_STATUS.BLOCKED_IN_OUT
  }

  get channel () {
    return this.accountNumbers[0]?.channel ?? null
  }

  static get statusOptions () {
    return [
      { name: 'Active', value: CUSTOMER_STATUS.ACTIVE },
      { name: 'Blocked', value: CUSTOMER_STATUS.BLOCKED_IN_OUT }
    ]
  }

  static get typeOptions () {
    return [
      { name: 'Legal', value: CUSTOMER_TYPES.LEGAL },
      { name: 'Private', value: CUSTOMER_TYPES.PRIVATE }
    ]
  }

  get schema () {
    return [
      'id',
      'walletId',
      'name',
      'regNumber',
      'registrationDate',
      'country',
      'city',
      'street',
      'zip',
      'citizenship',
      'type',
      'status',
      'parentProfileId',
      'accountNumbers'
    ]
  }

  toFormData () {
    return {
      accountId: this.walletId,
      channel: this.channel,
      name: this.name,
      regNumber: this.regNumber,
      registrationDate: this.registrationDate,
      country: this.country,
      city: this.city,
      street: this.street,
      zip: this.zip,
      citizenship: this.citizenship,
      type: this.type,
      status: this.status,
      accountNumbers: this.accountNumbers
    }
  }
}

export const CUSTOMER_STATUS = {
  ACTIVE: 'ACTIVE',
  BLOCKED_IN_OUT: 'BLOCKED_IN_OUT'
}

export const CUSTOMER_TYPES = {
  PRIVATE: 'PRIVATE',
  LEGAL: 'LEGAL'
}

export default ProfileCustomer
